"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tornimparte": {
    "c74ddfc9": [{
      "hkey": "74d93cb0",
      "slug": "tornimparte",
      "name": "Tornimparte",
      "primary": true,
      "skipSearch": false
    }],
    "colle-santa-maria": [{
      "hkey": "74d93cb0",
      "slug": "tornimparte",
      "name": "Tornimparte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "26850b15": [{
      "hkey": "74d93cb0",
      "slug": "tornimparte",
      "name": "Tornimparte",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-della-strada": [{
      "hkey": "74d93cb0",
      "slug": "tornimparte",
      "name": "Tornimparte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;